export default __webpack_public_path__ + "check_mark_no_bg.f8b385c0.svg";